import { apiClient } from '../../axios';

export const getHealthCheckApi = () => apiClient.get('/v2/health');
